import Model from "../_model";

export default class StockModel extends Model {
	constructor(provider) {
		super(provider, "stocks");
	}

	_parse(o) {
		if (o.createdAt) o.createdAt = this.parseDateTime(o.createdAt);
		if (o.updatedAt) o.updatedAt = this.parseDateTime(o.updatedAt);
		return super._parse(o);
	}

	find(id, { onSuccess, onFail }) {
		return super.find({ id, onSuccess, onFail });
	}

	filter({ filter = {}, pager, sorter, onSuccess, onFail }) {
		const params = {
			companyId: filter.companyId,
			productId: filter.productId,
			variantId: filter.variantId,
			warehouse: filter.warehouse,
			formatId: filter.formatId,
			measurementId: filter.measurementId,
			itemTypeRefIn: Array.isArray(filter.itemTypeRefIn) ? filter.itemTypeRefIn.join(",") : filter.itemTypeRefIn,
			positiveOnly: filter.positiveOnly,
			view: filter.view,
		};
		return super.filter({ params, pager, sorter, onSuccess, onFail });
	}

	create(i, { onSuccess, onFail }) {
		const body = {
			companyId: i.companyId,
			product: i.product,
			warehouse: i.warehouse,
			lotNo: i.lotNo || undefined,
			batches: i.batches || [],
		};
		return super.create(body, { onSuccess, onFail });
	}

	update(i, { onSuccess, onFail }) {
		const body = {};
		if (i.product !== undefined) body.product = i.product;
		if (i.warehouse !== undefined) body.warehouse = i.warehouse;
		if (i.lotNo !== undefined) body.lotNo = i.lotNo;
		if (i.batches !== undefined) body.batches = i.batches;
		return super.update(body, { id: i.id, onSuccess, onFail });
	}

	delete(id, { onSuccess, onFail }) {
		return super.delete({ id, onSuccess, onFail });
	}

	listView({ filter = {}, pager, sorter, lang, onSuccess, onFail }) {
		return this._get("stocks/listView", {
			params: {
				lang,
				text: filter.text,
				warehouse: filter.warehouse,
				lotNo: filter.lotNo,
				page: pager.number,
				size: pager.size,
				sortBy: sorter?.property,
				sortDesc: sorter?.method === "desc",
			},
			onSuccess,
			onFail,
		});
	}

	detailView({ id, lang = "en", onSuccess, onFail }) {
		return this._get("stocks/detailView", {
			params: { id, lang },
			onSuccess,
			onFail,
		});
	}

	getBatches(stockId, { quantityStatus, onSuccess, onFail }) {
		return this._get(`stocks/${stockId}/batches`, {
			params: { quantityStatus },
			onSuccess,
			onFail,
		});
	}

	addBatch(stockId, batch, { onSuccess, onFail }) {
		return this._post(`stocks/${stockId}/batches`, batch, { onSuccess, onFail });
	}

	updateBatch(stockId, batch, { onSuccess, onFail }) {
		const bid = batch.id || batch._id;
		return this._put(`stocks/${stockId}/batches/${bid}`, batch, { onSuccess, onFail });
	}

	deleteBatch(stockId, batchId, { onSuccess, onFail }) {
		return this._delete(`stocks/${stockId}/batches/${batchId}`, { onSuccess, onFail });
	}

	editMeta({ id, lang = "en", onSuccess, onFail }) {
		return this._get("stocks/editMeta", {
			params: { id, lang },
			onSuccess,
			onFail,
		});
	}
}
